import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from 'app/modules/utils-service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PiezasBienCulturalService } from './form-piezas-y-lotes.service';
import { PiezasBienCulturalInterface } from '../models/piezas-y-lotes.model';
import { PiezaBienCultural } from '../models/piezas-list.model';
import { MatTableModule } from '@angular/material/table';
import { Observable } from 'rxjs';

@Component({
    selector: 'fomr-piezas-lotes-bienes-muebles',
    templateUrl: 'form-piezas-y-lotes.component.html',
    imports:[
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
    ]
})

export class FormPiezasLotesBienesMueblesComponent implements OnInit {
    dataForm:PiezasBienCulturalInterface= null
    piezas$:Observable<PiezaBienCultural[]>
    displayedColumns: string[] = ['numeral', 'descripcion', 'acciones'];
    actualizarPieza:boolean= false

    numeroRegistro:string

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {uu_id:string, noRegistro:string},
        public dialogRef: MatDialogRef<FormPiezasLotesBienesMueblesComponent>,
        private _piezasBienCulturalService:PiezasBienCulturalService,
        private utilsService:UtilsService,
        
    ) {
        this.getPiezasBienCultural()

        this.dataForm= {bienCulturalUuid:this.data.uu_id, descripcion:'', numeral:''}
        this.numeroRegistro= this.data.noRegistro

        this.piezas$=this._piezasBienCulturalService.piezasBienCultural$
    }

    ngOnInit() { }


    postPiezas(){
         this.utilsService.open_confirm_dialog(
            `La pieza será registrada con el número ${this.numeroRegistro}.${this.dataForm.numeral}.
            Por favor, haga clic en Confirmar para completar el registro.`, 
            `Pieza ${this.numeroRegistro}.${this.dataForm.numeral}`
          )
        .subscribe(response=>{
            if (response === 'confirmed') {
                this._piezasBienCulturalService.postPiezasBienCultural(this.dataForm)
                .then((response:any)=>{
                    this.dataForm= {bienCulturalUuid:this.data.uu_id, descripcion:'', numeral:''}
                    this.utilsService.openSuccessSnakBar(response.message)
                    this.getPiezasBienCultural()
                })
            }
        })
        
    }

    getPiezasBienCultural(){
        this._piezasBienCulturalService.getPiezasBienCultural(this.data.uu_id)
    }

    editPiezaBienCultural(pieza:PiezaBienCultural){
        this.actualizarPieza= true
        this.dataForm.piezaId= pieza.piezaId
        this.dataForm.descripcion= pieza.descripcion
        this.dataForm.numeral= pieza.numeral  
    }

    actualizarPiezasBienCultural(){            
        this._piezasBienCulturalService.actualizarPiezasBienCultural(this.dataForm)
        .then((response:any)=>{
            this.dataForm= {bienCulturalUuid:this.data.uu_id, descripcion:'', numeral:''}
            this.actualizarPieza= false
            this.utilsService.openSuccessSnakBar(response.message)     
            this.getPiezasBienCultural()
        })     
    }

    deletePiezaBienCultural(uu_id_pieza:number){
        this.utilsService.open_confirm_dialog(
            `¿Está seguro de eliminar la pieza?`,
            `Eliminar Pieza`
          )
        .subscribe(response=>{
            if (response === 'confirmed') {
                this._piezasBienCulturalService.deletePiezasBienCultural(uu_id_pieza)
                .then((response:any)=>{
                    this.utilsService.openSuccessSnakBar(response.message)
                    this.getPiezasBienCultural()
                })
            }
        })
    }

}